import { Mail, Phone, MapPin } from 'lucide-react';
import { useTenant } from '../../context/TenantContext.jsx';

/** Kontaktseite (/kontakt). Zeigt nur hinterlegte Mandantendaten; keine erfundenen Angaben. */
export function ContactView() {
  const { tenant } = useTenant();
  const email = tenant?.contactEmail && !/kontakt-pending@|\.invalid$/i.test(tenant.contactEmail) ? tenant.contactEmail : '';
  const phone = tenant?.phone || '';
  const address = tenant?.address;
  const addressText = typeof address === 'string' ? address : [address?.company, address?.street, [address?.zip, address?.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 space-y-8" data-testid="contact-page">
      <div className="text-center space-y-2 border-b border-[var(--border)] pb-8">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[var(--foreground)]">Kontakt</h1>
        <p className="text-sm text-[var(--secondary)]">So erreichen Sie uns persönlich.</p>
      </div>
      <div className="rounded-xl border border-[var(--border)] bg-white p-6 shadow-sm space-y-4 text-sm text-[var(--foreground)]">
        {email && (<p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[var(--primary)]" /><a href={`mailto:${email}`} className="underline">{email}</a></p>)}
        {phone && (<p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[var(--primary)]" /><a href={`tel:${phone.replace(/[^0-9+]/g, '')}`} className="underline">{phone}</a></p>)}
        {addressText && (<p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[var(--primary)]" />{addressText}</p>)}
        {!email && !phone && !addressText && (
          <p className="text-[var(--secondary)]">Kontaktdaten werden in Kürze hier veröffentlicht. Bitte nutzen Sie bis dahin das Formular im Anfragekorb.</p>
        )}
      </div>
    </div>
  );
}
